//用户信息

<template>
<div class="">
	<header-vue></header-vue>
  <div class="container-l2">
  	<h1 class="h11">用户管理</h1>
	<div class="clear marBottom30">
	  	<div class="search-box">
	  		<p class="log_warn" v-if="ifwarn" v-text="warntxt"></p>
			<input placeholder="请输入添加成员的手机号" v-model="userTel" @keyup.enter="showUser()" class="log-input search-input" />
			<el-button @click="showUser()"> 搜 索 </el-button>
		</div>
  	</div>
    <el-table
    	stripe
		border
	    ref="multipleTable"
	    :data="userList"
	    tooltip-effect="dark"
	    style="width: 100%">
	    <el-table-column
	      prop="username"
	      label="手机号码"
	      show-overflow-tooltip>
	    </el-table-column>
	    <el-table-column
	      prop="real_name"
	      label="姓名"
	      width="120">
	    </el-table-column>
	    
	    <el-table-column
	      prop="email"
	      label="邮箱"
	      show-overflow-tooltip>
	    </el-table-column>
	    <el-table-column
	      prop="company"
	      label="所属公司"
	      show-overflow-tooltip>
	    </el-table-column>
	    <el-table-column
	      prop="administrators"
	      label="身份"
	      :formatter="formatAdmin"
	      show-overflow-tooltip>
	    </el-table-column>
	    
	    <el-table-column
	      prop="register_time"
	      label="注册日期"
	      :formatter="dateFormat"
	      width="120">
	    </el-table-column>
	    <el-table-column
          label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small"
                       @click="showMod(scope.$index, scope.row)">编辑
            </el-button>
            <el-button type="text" size="small"
                       @click="removeUser(scope.$index, scope.row)">移除
            </el-button>
          </template>
        </el-table-column>
	  </el-table>
	  <br />
	  <br />
	  <div class="text-right">
			<el-pagination
				@current-change="handleCurrentChange"
			  :page-size="pageSize"
			  :pager-count="11"
			  layout="total, prev, pager, next"
			  :total="totalNum">
			</el-pagination>
		</div>
	  <!--搜索用户信息-->
		<el-dialog title="搜索用户信息" :visible.sync="userDetail" width="500px" >
		    <div class="userInfo" v-if="addUser.username">
				<div>
					<span class="span3">姓名：</span>
					<span class="" v-text="addUser.real_name"></span>
				</div>
				<div>
					<span class="span3">手机号码：</span>
					<span class="" v-text="addUser.username"></span>
				</div>
				<div>
					<span class="span3">注册时间：</span>
					<span class="" v-text="dateFormat3(addUser.register_time)"></span>
				</div>
				<div>
					<span class="span3">所属公司：</span>
					<span class="" v-text="addUser.company_name || '无'"></span>
				</div>
			</div>
			<div class="userInfo" v-if="!addUser.username">
				<h4>你搜索的用户不存在！</h4>
			</div>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="userDetail = false">关闭</el-button>
			    <el-button type="primary" v-if="addUser.company_id==0" @click="confirmAddNewUser()">确认添加</el-button>
			  </div>
		</el-dialog>
		<!--编辑弹框-->
		<el-dialog title="用户信息编辑" :visible.sync="editFlag" width="500px">
        
	        <el-form :model="editUser" ref="editUser" label-width="100px">
	        	
	          <el-form-item label="用户名1">
	          	<span v-text="editUser.username"></span>
	          </el-form-item>
	          <el-form-item label="公司名称">
	          	<span v-text="editUser.company"></span>
	          </el-form-item>
	          <el-form-item label="真实姓名">
	            <el-input v-model="editUser.real_name" placeholder="请输入厂商名称" auto-complete="off"></el-input>
	          </el-form-item>
	          <el-form-item label="邮箱">
	            <el-input v-model="editUser.email" placeholder="请输入厂商名称" auto-complete="off"></el-input>
	          </el-form-item>
	        </el-form>
	        <div slot="footer" class="dialog-footer">
	          <el-button @click="editFlag=false">取 消</el-button>
	          <el-button type="primary" @click="conMod()">确定</el-button>
	        </div>
	    </el-dialog>
		<!--移除提示框-->
		<el-dialog title="提示框" :visible.sync="removeUserFlag" width="500px" >
		    <div class="userInfo">
				<h4>确认移除该用户吗？</h4>
			</div>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="removeUserFlag = false">关闭</el-button>
			    <el-button type="primary" @click="confirmRemovUser()">确认移除</el-button>
			  </div>
		</el-dialog>
  </div>


</div>
</template>
<script>
	export default {
		mounted() {
			this.$nextTick(function(){
		  		
		  		this.getUserList();
		  	})
    	},
		components:{
		},
		data() {
	      return {
	      	userDetail:false,
	      	removeUserFlag:false,
	        userList:[],
	        multipleSelection: [],
	        userTel:"",
	        addUser:{},
	        removeIndex:"",
	        removeRow:{},
	        ifwarn:false,
		  	warntxt:'',
		  	nowPage:1,
		  	pageSize:12,
		  	totalNum:0,
		  	editUser:{},
		  	editFlag:false
	      }
	    },
		methods:{
			handleCurrentChange(val) {
		        this.nowPage = val;
		        this.getUserList();
		      },
			formatAdmin(row, column){
				switch(parseInt(row.administrators)){
					case 1:
						return "普通用户";
						break;
					case 2:
						return "管理员";
						break;
					case 3:
						return "超级管理员";
						break;
				}
			},
			dateFormat(row, column) {
               var date = row[column.property];
		          if (date == undefined) {
		             return "";
		          }
		          return this.$moment(date*1000).format("YYYY-MM-DD");
           },
           showMod(index,row){
           		this.editFlag = true;
           		this.editUser = row;
           },
           conMod(){
           		let savePersoParams={
		  			uid:this.editUser.uid,
		  			timestamp:Date.parse( new Date()),
		  		    terminalId:4,
		  		    real_name:this.editUser.real_name || '',
		  		    email:this.editUser.email || ''
		  		};
		  		this.sign(savePersoParams);
		  		this.$ajax.post(this.$store.state.domain+"/Home/PersonalData/Preservation",this.$qs.stringify(savePersoParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.status==1){
		        		this.$message.success(res.data.msg);
		        		this.editFlag = false;
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        		this.$message.error(res.data.msg);
		        	}
		  		});
           },
			getUserList(){
				let valiCodeParams={
					uid:this.getCookie('uid'),
			  		timestamp:Date.parse( new Date()),
			  		terminalId:4,
		  			company_id:this.getCookie('company_id'),
		  			page:this.nowPage.toString(),
	  				pagesize:this.pageSize.toString(),
		  		};
		  		this.sign(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain+"/Home/UserList/UserList",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.status==1){
		        		this.userList = res.data.data.name || [];
		        		if(res.data.data.pagecount){
		        			this.totalNum = parseInt(res.data.data.pagecount);
		        		}
		        		
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        		this.ifwarn = true;
		        		this.warntxt = res.data.msg;
		        	}
		  		});
			},
			showUser(){
				this.ifwarn = false;
				this.warntxt = '';
				var reg=11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
				if(this.userTel==""){
					this.ifwarn = true;
					this.warntxt = '手机号不能为空';
				}
				else if(!reg.test(this.userTel)){
					this.ifwarn = true;
					this.warntxt = '请输入正确的手机号码';
				}else{
					this.userDetail = true;
					let valiCodeParams={
						uid:this.getCookie('uid'),
				  		timestamp:Date.parse( new Date()),
				  		terminalId:4,
			  			keyword:this.userTel,
			  		};
			  		this.sign(valiCodeParams);
			  		this.$ajax.post(this.$store.state.domain+"/Home/UserFind/UserFind",this.$qs.stringify(valiCodeParams),{
			            emulateJSON: true
			        }).then(res=>{
			        	if(res.data.status==1){
			        		this.addUser = res.data.data || {};
			        		
			        	}else if(res.data.code==10008){
			        		this.delCookie('username');
							this.$router.push('/login/');
							this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);  
			        	}else{
			        		//console.log(res.data.msg);
			        		this.ifwarn = true;
			        		this.warntxt = res.data.msg;
			        	}
			  		});
				}
				
			},
			removeUser(index,row){
				this.removeUserFlag = true;
				this.removeRow = row;
			},
			confirmRemovUser(){
				let valiCodeParams={
					uid:this.getCookie('uid'),
			  		timestamp:Date.parse( new Date()),
			  		terminalId:4,
		  			username:this.removeRow.username
		  		};
		  		this.sign(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain+"/Home/UserDel/UserDel",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.status==1){
		        		this.removeUserFlag = false;
		        		this.$message.success(res.data.msg);
		        		this.getUserList();
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);  
		        	}else{
		        		//console.log(res.data.msg);
		        		this.$message.error(res.data.msg);
		        	}
		  		});
			},
			confirmAddNewUser(){
				this.userDetail = true;
				let valiCodeParams={
					uid:this.getCookie('uid'),
			  		timestamp:Date.parse( new Date()),
			  		terminalId:4,
		  			company_id:this.getCookie('company_id'),
		  			username:this.addUser.username
		  		};
		  		this.sign(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain+"/Home/UserAdd/UserAdd",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.status==1){
		        		this.userDetail = false;
		        		this.$message.success(res.data.msg);
		        		this.getUserList();
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);
		        	}else{
		        		//console.log(res.data.msg);
		        		this.ifwarn = true;
		        		this.warntxt = res.data.msg;
		        	}
		  		});
			}
		}
	}

</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/choosepeople.vue